/**
 * Na Home: **sempre o próximo aniversário do grupo** (decisão do PO, 17/09/2026,
 * lote de aparência 2) — "Hoje", "Amanhã", "Sábado" quando é perto, "12/11"
 * quando é longe; todos os do mesmo dia. Nada de idade. Some quando a viagem
 * tem uma pessoa só: não há grupo para lembrar.
 */
import { featureEnabled, formatDayMonth, upcomingBirthdays, weekdayName, type CalendarDate } from '@nv/core';

import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { useAniversariosDaViagem } from './api';

/** Um ano inteiro: o próximo aniversário existe sempre que alguém tem data. */
const JANELA_DIAS = 366;

function quando(daysUntil: number, date: CalendarDate): string {
  if (daysUntil === 0) return 'Hoje';
  if (daysUntil === 1) return 'Amanhã';
  if (daysUntil <= 6) {
    // "DOMINGO" é o formato do cabeçalho do dia; aqui é frase.
    const nome = weekdayName(date).toLowerCase();
    return nome.charAt(0).toUpperCase() + nome.slice(1);
  }
  return `Dia ${formatDayMonth(date)}`;
}

export function AniversariosNaHome({ hoje }: { hoje: CalendarDate | null }) {
  const { trip, tripId, meuMemberId, members } = useTrip();
  const ligado = featureEnabled(trip.features, 'aniversarios') && members.length > 1;
  const lista = useAniversariosDaViagem(tripId, ligado);
  if (!ligado || !hoje || !lista.data) return null;
  const todos = upcomingBirthdays(lista.data.birthdays, hoje, JANELA_DIAS).sort((a, b) => a.daysUntil - b.daysUntil);
  const primeiro = todos[0];
  if (!primeiro) return null;
  // Só o próximo — e quem faz aniversário no mesmo dia que ele.
  const proximos = todos.filter((b) => b.daysUntil === primeiro.daysUntil);
  return (
    <div className="aniv" data-testid="aniversarios">
      {proximos.map((b) => (
        <p className={b.daysUntil === 0 ? 'aniv__faixa aniv__faixa--hoje' : 'aniv__faixa'} key={`${b.memberId}-${b.date}`} role="status">
          <span className="aniv__icone" aria-hidden="true"><Icon name="bolo" size={18} /></span>
          <span>
            {b.memberId === meuMemberId ? (
              <>{quando(b.daysUntil, b.date)} é o <b>seu</b> aniversário{b.daysUntil === 0 ? ' — parabéns!' : ''}</>
            ) : (
              <>{quando(b.daysUntil, b.date)} é aniversário de <b>{b.name}</b></>
            )}
          </span>
        </p>
      ))}
    </div>
  );
}
